/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
// External deps
import { useState, useEffect, useContext, useMemo } from 'react';
import { Button } from 'ypf-pas-general-ui-components';
import { useParams, useHistory } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { BsPlusCircle, BsDownload } from 'react-icons/bs';
import PropTypes from 'prop-types';
import { MdFilterAlt } from 'react-icons/md';
// Internal deps
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { AiOutlineDownload } from 'react-icons/ai';

import { ReactComponent as ExtendedViewIcon } from '../../assets/images/extended-view-icon.svg';
import UbicationAccordion from '../MonthlyServiceRequest/CustomAccordion/UbicationAccordion';
import CustomCheck from '../MonthlyServiceRequest/CustomCheck/CustomCheck';
import PositionLineAccordion from '../MonthlyServiceRequest/CustomAccordion/PositionLineAccordion';
import useUbicationPositionLine from '../../hooks/useUbicationPositionLine';
import useToast from '../../hooks/useToast';
import NoUbications from '../MonthlyServiceRequest/NoData/NoUbications';
import AddPLToUbicationModal from '../MonthlyServiceRequest/Modals/AddPLToUbicationModal/AddPLToUbicationModal';
import { typeUbicationSS } from '../../services/yclickMaster';
import {
  getMonthlyBusinessUnits,
  downloadWorkReportMSDS,
  getMonthlyOperations,
  getFinishedServiceAvailability,
  setMonthlyFinishedService
} from '../../services/monthlyServiceRequest';
import AddUbicationsToPL from '../MonthlyServiceRequest/Modals/AddUbicationsToPL/AddUbicationsToPL';
import {
  assignmentTypeEnum,
  statusEnum as statusEnumSDS,
  ubicationTypeEnum
} from '../../utils/dataStatus';
import LoaderContext from '../../context/LoaderProvider';
import {
  TypeAndObjectImputationPermissions,
  WorkPartPermissions,
  AttachedFilesPermissions
} from '../MonthlyServiceRequest/RequestDetailTypes';
import { deleteUbication } from '../../services/workReport';
import { postCreateLocation } from '../../adapters/monthlyRequestService/monthlyRequestService';
import { FilesSdsPtContext } from '../../context/FilesSdsPtContext';
import { useWorkReportModals } from '../../context/WorkReportModalsContext';
import useUbicationAccordion from '../../hooks/useUbicationAccordion';
import DeleteUbicationModal from '../MonthlyServiceRequest/Modals/DeleteUbicationModal';
import { getFirstDayOfMonth, getLastDateOfMonth, MONTHS } from '../../utils/formatUtils';
import FinishedServiceModal from '../MonthlyServiceRequest/Modals/FinishedServiceModal';
import { checkRol } from '../../security';
import { proveedorNotificador, notificador } from '../../security/constantsRols';
import { useFilterContext } from '../../context/FilterDetailSDSContext';
import { useDrawerContext } from '../../context/DrawerContext';
import { downloadPreticket } from '../../services/programPointsService';
import { useDetailServiceRequest } from '../../context/DetailServiceRequestProvider';

import ModalAddLocation from './MonthlyWorkReport/ModalAddLocation/ModalAddLocation';
import ModalMonthlyImputationObject from './MonthlyWorkReport/ModalMonthyImputationObject/ModalMonthlyImputationObject';
import './LocationWorkReports.scss';
import FilterWorkReport from './FilterWorkReports/FilterWorkReport';
import SupportingDocumentMultipleButton from './SupportingDocumentMultipleButton/SupportingDocumentMultipleButton';

const getButtonVariant = (isOrderByUbication) =>
  isOrderByUbication ? 'primary' : 'outline-primary';

const getButtonText = (isOrderByUbication) =>
  isOrderByUbication
    ? 'Agregar posición y línea a ubicaciones'
    : 'Agregar ubicación a posiciones y líneas';

const getCloseAllText = (isOrderByUbication) =>
  isOrderByUbication ? 'Cerrar todas las ubicaciones' : 'Cerrar todas las posiciones y líneas';

const isStatusCancelledOrFinalized = (idStatus) =>
  idStatus === statusEnumSDS.cancelada || idStatus === statusEnumSDS.finalizada;

const isTemplateDefined = (template) => template || false;

const LocationWorkReports = ({
  contractNumber,
  idStatus,
  month,
  hasLocations,
  number,
  IOPermissions,
  workPartPermissions,
  isOyM,
  asignationType,
  filesPermissions,
  requestData,
  getDetailsMonthlyHeader,
  notificaPP,
  eventos
}) => {
  // Refers to selected locations or position–lines
  // The array will store the IDs of the selected locations
  // or the selected position–lines

  const [hasPositionLines, setHasPositionLines] = useState(false);
  const [refreshHasLocations, setRefreshHasLocations] = useState(hasLocations);
  const [newLineAdded, setNewLineAdded] = useState(false);
  const [paramsLocation, setParamsLocation] = useState({
    optionsUbicationType: [],
    optionsBusinessOptions: []
  });
  const [showAddUbicationsToPLModal, setShowAddUbicationsToPLModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [finishedServiceInfo, setFinishedServiceInfo] = useState({});
  const [deleteUbicationInfo, setDeleteUbicationInfo] = useState({ id: null, nombre: null });
  const { activeTemplateWorkReportModal } = useWorkReportModals();
  const { id } = useParams();
  const { setNewToast } = useToast();

  const { filter } = useFilterContext();
  const {
    data,
    isOrderByUbication,
    setIsOrderByUbication,
    setRefreshFetch,
    getUbicationsOLines,
    refreshFetch
  } = useUbicationPositionLine(id, refreshHasLocations, filter);
  const { activeDrawer, setActiveDrawer, closeDrawer } = useDrawerContext();

  const { details } = useDetailServiceRequest();

  const { setLoader } = useContext(LoaderContext);
  const { setIsMonthly } = useContext(FilesSdsPtContext);

  const firstDayOfSSM = getFirstDayOfMonth(
    MONTHS.indexOf(month.split(' ')[0]),
    month.split(' ')[1]
  );
  const lastDayOfSSM = getLastDateOfMonth(MONTHS.indexOf(month.split(' ')[0]), month.split(' ')[1]);

  const fetchDataWithDefaultParams = () => {
    setRefreshFetch((oldValue) => !oldValue);
  };

  const disabledEditStateCancelOrFinish = isStatusCancelledOrFinalized(idStatus);

  const history = useHistory();
  const { template, search } = useLocation();

  const [templateActive, setTemplateActive] = useState(isTemplateDefined(template));

  // Ordered by Location
  const ubications = data?.solicitudServicioMensualizadaUbicaciones;

  // Ordered by Position and Line
  const positionsLines = data?.parteTrabajoLineaMensualizadas;

  const {
    accordionsSelecteds,
    changeSetAccordionsOpens,
    changeSetAccordionsSelecteds,
    isAllAccordionsSelecteds,
    handleOpenAccordion,
    handleOpenModalImputationObject,
    handleCloseModalImputationObject,
    showFinishedServiceModal,
    handleShowModalFinishedService,
    modalImputationObject,
    handleSelectAll,
    handleUnselectAll,
    closeAllAccordions,
    isSomeAccordionOpen,
    closeAccordions,
    modalAddLocation,
    handleCloseModalAddLocation,
    handleOpenModalAddLocation,
    showAddPLToUbicationModal,
    changeAddPLToUbicationState
  } = useUbicationAccordion({
    idStatus
  });

  // Select all locations or position–lines
  // if all locations or position–lines are selected
  // then unselect them

  useEffect(() => {
    changeSetAccordionsOpens([]);
    const accordionsUbicationsOpens = data?.solicitudServicioMensualizadaUbicaciones?.map(
      (item) => ({
        id: item?.id,
        isOpen: false
      })
    );

    const accordionsPositionsLinesOpens = data?.parteTrabajoLineaMensualizadas?.map((item) => ({
      id: item?.id,
      isOpen: false
    }));

    if (isOrderByUbication) {
      setHasPositionLines(data?.tienePosicionLinea);
      changeSetAccordionsOpens(accordionsUbicationsOpens);
    } else {
      changeSetAccordionsSelecteds([]);
      changeSetAccordionsOpens(accordionsPositionsLinesOpens);
    }
  }, [data, isOrderByUbication]);

  const areAllSelected = isOrderByUbication
    ? isAllAccordionsSelecteds(accordionsSelecteds, ubications)
    : isAllAccordionsSelecteds(accordionsSelecteds, positionsLines);

  useEffect(() => {
    if (data?.ordenarPorUbicacion && data?.solicitudServicioMensualizadaUbicaciones?.length === 0) {
      setRefreshHasLocations(false);
    }
  }, [data]);

  useEffect(() => {
    if (templateActive) {
      activeTemplateWorkReportModal({
        onAccept: fetchDataWithDefaultParams,
        monthly: true,
        // was applied
        applied: false,
        contractNumber,
        disabledEditStateCancelOrFinish,
        initialDate: firstDayOfSSM,
        endingDate: lastDayOfSSM
      });
      setTemplateActive(false);
    }
  }, [templateActive]);

  useEffect(() => {
    const getParams = async () => {
      if (workPartPermissions.addUbication) {
        try {
          const includeGenericTypes = !!isOyM;
          const responseUbicationType = await typeUbicationSS(includeGenericTypes);
          const responseBusinessUnits = await getMonthlyBusinessUnits(id);
          const responseOperations = await getMonthlyOperations(id);

          setParamsLocation({
            optionsUbicationType: isOyM
              ? responseUbicationType.filter(
                  (ubication) =>
                    ubication.id !== ubicationTypeEnum.locacion &&
                    ubication.id !== ubicationTypeEnum.pozo
                )
              : responseUbicationType.filter(
                  (ubication) =>
                    ubication.id !== ubicationTypeEnum.ducto &&
                    ubication.id !== ubicationTypeEnum.edificio &&
                    ubication.id !== ubicationTypeEnum.pozoOyM &&
                    ubication.id !== ubicationTypeEnum.plantaAyP &&
                    ubication.id !== ubicationTypeEnum.plantaGas &&
                    ubication.id !== ubicationTypeEnum.uspYBateria &&
                    ubication.id !== ubicationTypeEnum.almacen &&
                    ubication.id !== ubicationTypeEnum.talleresYBasesDeProveedores &&
                    ubication.id !== ubicationTypeEnum.energia &&
                    ubication.id !== ubicationTypeEnum.locacionOYM
                ),
            filteredBusinessUnits: responseBusinessUnits,
            filteredOperations: responseOperations,
            disabledChangeUunn: true
          });
        } catch (err) {
          setNewToast({
            type: 'ERROR',
            message: err.message
          });
        }
      }
    };

    getParams();
    setIsMonthly(asignationType === assignmentTypeEnum.Mensualizada);
  }, []);

  const handleNewPositionLineAdded = () => {
    setNewLineAdded(!newLineAdded);
    getUbicationsOLines();
  };

  const download = async () => {
    setLoader(true);
    setNewToast({
      type: 'INFO',
      message: 'Descargando, por favor espere.'
    });
    try {
      await downloadWorkReportMSDS(id);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const allSelectedHavePosicionLinea = accordionsSelecteds.some((selectedId) => {
    const ubicacion = ubications?.find((u) => u.id === selectedId);

    return ubicacion?.finalizada === false && ubicacion?.tienePosicionLinea === true;
  });

  const handleDownloadPreticket = async () => {
    try {
      setLoader(true);

      const locationIdsToDownload = accordionsSelecteds
        .map((selectedId) => {
          const ubicacion = ubications?.find((u) => u.id === selectedId);

          if (ubicacion?.finalizada === true || ubicacion?.tienePosicionLinea === false) {
            return null;
          }

          return ubicacion?.idUbicacion || ubicacion?.id;
        })
        .filter((ubicacionId) => ubicacionId && ubicacionId !== null && ubicacionId !== undefined);

      setNewToast({
        type: 'INFO',
        message: `Descargando modelo de preticket.`
      });

      const downloadPayload = {
        idSolicitud: id,
        nroContrato: contractNumber,
        mensualizada: true,
        idsUbicaciones: locationIdsToDownload,
        numero: details?.numero,
        servicio: details?.servicio?.nombre
      };

      await downloadPreticket(downloadPayload);

      setNewToast({
        type: 'SUCCESS',
        message: 'Descarga completada correctamente.'
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoader(false);
    }
  };

  const submitAddLocationsMSDS = async (values) => {
    await postCreateLocation(id, values, isOyM);
    setRefreshFetch((val) => !val);
  };

  const deleteUbicationSelected = async (idUbication) => {
    try {
      await deleteUbication(idUbication);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: 'Ubicación eliminada correctamente'
      });
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
    setRefreshFetch((refresh) => !refresh);
  };
  const updateDeleteUbicationInfo = (idUbication, nombre) => {
    setDeleteUbicationInfo({ id: idUbication, nombre });
  };

  const isFinishedServiceAvailability = async (idUbication) => {
    try {
      const response = await getFinishedServiceAvailability(idUbication);

      return response;
    } catch (error) {
      return error;
    } finally {
      setRefreshFetch((refresh) => !refresh);
    }
  };

  const handleSetFinishedService = async (locationId) => {
    setLoader(true);
    try {
      const response = await setMonthlyFinishedService(id, locationId);

      getDetailsMonthlyHeader();
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: response
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
    setRefreshFetch((refresh) => !refresh);
  };

  const isProviderOrNotifier = useMemo(
    () => checkRol(proveedorNotificador) || checkRol(notificador),
    []
  );

  const isActiveService = useMemo(() => idStatus === statusEnumSDS.enEjecucion, [idStatus]);

  return (
    <>
      <FilterWorkReport
        hide={closeDrawer}
        isOrderByUbication={isOrderByUbication}
        show={activeDrawer}
      />
      <Row>
        <Col className="d-flex justify-content-start align-items-center my-2" sm={5}>
          <>
            {checkRol(proveedorNotificador) && (
              <Button
                className="button-filters"
                color="primary"
                icon={MdFilterAlt}
                onClick={() => setActiveDrawer(true)}
                sizeIcon="20px"
                type="button"
                variant="white"
                widthButton="40px"
              >
                Filtros
              </Button>
            )}
            <Button
              fontSizeLabel="16px"
              label="Ordenar por Ubicación"
              onClick={() => setIsOrderByUbication(true)}
              type="button"
              variant={getButtonVariant(isOrderByUbication)}
              widthButton="155px"
            />
            <Button
              className="mx-2"
              colorIcon="primary"
              disabled={!hasPositionLines}
              fontSizeLabel="16px"
              label="Ordenar por Posición y Línea"
              onClick={() => setIsOrderByUbication(false)}
              type="button"
              variant={getButtonVariant(!isOrderByUbication)}
              widthButton="200px"
            />
          </>
        </Col>
        <Col className="d-flex justify-content-end my-2" sm={7}>
          {ubications?.length || positionsLines?.length ? (
            <>
              <Button
                className="extended-view-btn"
                colorIcon="primary"
                disabled={
                  !hasPositionLines ||
                  !workPartPermissions.simplifiedCharging.visualize ||
                  (isOrderByUbication && !data?.solicitudServicioMensualizadaUbicaciones?.length)
                }
                fontSizeLabel="15px"
                icon={ExtendedViewIcon}
                iconRight
                label="Carga simplificada"
                onClick={() =>
                  history.push({
                    pathname: `/detailmonthly/${id}/simplifiedcharging/${month.split(' ')[0]}/${
                      month.split(' ')[1]
                    }/${isOrderByUbication}/${number}`,
                    disabled: disabledEditStateCancelOrFinish
                  })
                }
                type="button"
                variant="light-gray"
                widthButton="180px"
              />
              <Button
                className="mx-2"
                colorIcon="primary"
                disabled={!hasPositionLines}
                fontSizeLabel="15px"
                icon={BsDownload}
                iconRight
                label="Descargar parte"
                onClick={() => {
                  download();
                }}
                sizeIcon="17px"
                type="button"
                variant="light-gray"
                widthButton="180px"
              />
            </>
          ) : null}
          {!ubications?.length && !positionsLines?.length && (
            <Button
              className="mx-2"
              colorIcon="primary"
              disabled={!workPartPermissions.addUbication || disabledEditStateCancelOrFinish}
              icon={BsPlusCircle}
              iconRight
              label="Aplicar Plantilla"
              onClick={() => {
                activeTemplateWorkReportModal({
                  onAccept: fetchDataWithDefaultParams,
                  monthly: true,
                  // was applied
                  applied: false,
                  contractNumber,
                  disabledEditStateCancelOrFinish,
                  initialDate: firstDayOfSSM,
                  endingDate: lastDayOfSSM
                });
              }}
              sizeIcon="17px"
              type="button"
              variant="light-gray"
              widthButton="200px"
            />
          )}
          <Button
            className="mx-2"
            colorIcon="primary"
            disabled={disabledEditStateCancelOrFinish || !workPartPermissions.addUbication}
            fontSizeLabel="15px"
            icon={BsPlusCircle}
            iconRight
            label="Agregar ubicación"
            onClick={() => {
              handleOpenModalAddLocation();
            }}
            sizeIcon="17px"
            type="button"
            variant="light-gray"
            widthButton="180px"
          />
        </Col>
      </Row>
      <hr />
      <div className="location-workreports-container">
        {data?.solicitudServicioMensualizadaUbicaciones?.length ||
        data?.parteTrabajoLineaMensualizadas?.length ? (
          <>
            {data && (
              // Header contains:
              // Button to order by locations or position–lines
              // Select all accordionsOpens
              // Add location or position–line
              // Close all accordions
              <>
                <div className="d-flex justify-content-between my-2 align-items-center w-100">
                  <div className="d-flex">
                    <CustomCheck
                      isChecked={areAllSelected}
                      onChange={() => {
                        if (areAllSelected) {
                          handleUnselectAll();
                        } else {
                          handleSelectAll(isOrderByUbication ? ubications : positionsLines);
                        }
                      }}
                    />
                    <Button
                      className="mx-2"
                      colorIcon="primary"
                      disabled={
                        accordionsSelecteds?.length === 0 ||
                        !workPartPermissions.addPositionLine ||
                        disabledEditStateCancelOrFinish
                      }
                      icon={BsPlusCircle}
                      iconRight
                      label={getButtonText(isOrderByUbication)}
                      onClick={
                        isOrderByUbication
                          ? () => changeAddPLToUbicationState(true)
                          : () => setShowAddUbicationsToPLModal(true)
                      }
                      sizeIcon="17px"
                      type="button"
                      variant="light-gray"
                      widthButton="300px"
                    />
                    {isProviderOrNotifier && (
                      <Button
                        className="mx-2"
                        colorIcon="primary"
                        disabled={
                          accordionsSelecteds?.length === 0 ||
                          !workPartPermissions.addPositionLine ||
                          !isOrderByUbication ||
                          disabledEditStateCancelOrFinish ||
                          !allSelectedHavePosicionLinea
                        }
                        fontSizeLabel="15px"
                        icon={AiOutlineDownload}
                        iconRight
                        label="Descargar modelo de preticket"
                        onClick={() => {
                          handleDownloadPreticket();
                        }}
                        sizeIcon="17px"
                        type="button"
                        variant="light-gray"
                        widthButton="250px"
                      />
                    )}
                    {isProviderOrNotifier && (
                      <SupportingDocumentMultipleButton
                        data={{
                          ...data,
                          idSolicitud: Number(requestData.nroSolicitud)
                        }}
                        disabled={!isActiveService}
                        maxDate={lastDayOfSSM}
                        minDate={firstDayOfSSM}
                        monthly
                        selectedDate={firstDayOfSSM}
                        setNewFetch={setRefreshFetch}
                      />
                    )}
                  </div>
                  <Button
                    className="blue-out-line-button"
                    colorButton="primary"
                    disabled={!isSomeAccordionOpen()}
                    label={getCloseAllText(isOrderByUbication)}
                    onClick={closeAllAccordions}
                    type="button"
                    widthButton="250px"
                  />
                </div>
                {isOrderByUbication
                  ? data.solicitudServicioMensualizadaUbicaciones?.length > 0 &&
                    data.solicitudServicioMensualizadaUbicaciones
                      .sort((a, b) => a.nombreEquipo - b.nombreEquipo)
                      .map((ubication) => (
                        <UbicationAccordion
                          IOPermissions={IOPermissions}
                          accordionData={ubication}
                          accordionsSelecteds={accordionsSelecteds}
                          asignationType={asignationType}
                          byUbication
                          closeAccordions={closeAccordions}
                          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                          filesPermissions={filesPermissions}
                          finishedServiceInfo={finishedServiceInfo}
                          handleOpenAccordion={handleOpenAccordion}
                          hasPositionLines={ubication.tienePosicionLinea}
                          isFinishedServiceAvailable={isFinishedServiceAvailability}
                          isOyM={isOyM}
                          key={ubication.id}
                          month={month.split(' ')[0]}
                          newLineAdded={newLineAdded}
                          notificaPP={notificaPP}
                          refreshFetch={refreshFetch}
                          requestData={requestData}
                          search={search}
                          setAccordionsSelecteds={changeSetAccordionsSelecteds}
                          setFinishedServiceInfo={setFinishedServiceInfo}
                          setOpenModal={handleOpenModalImputationObject}
                          setRefreshFetch={setRefreshFetch}
                          setShowAddPLToUbicationModal={changeAddPLToUbicationState}
                          setShowDeleteModal={setShowDeleteModal}
                          setShowFinishedServiceModal={handleShowModalFinishedService}
                          showFinishedServiceModal={showFinishedServiceModal}
                          updateDeleteUbicationInfo={updateDeleteUbicationInfo}
                          workPartPermissions={workPartPermissions}
                          year={month.split(' ')[1]}
                        />
                      ))
                  : data.parteTrabajoLineaMensualizadas?.length > 0 &&
                    data.parteTrabajoLineaMensualizadas?.map((positionLine) => (
                      <PositionLineAccordion
                        IOPermissions={IOPermissions}
                        accordionData={positionLine}
                        accordionsSelecteds={accordionsSelecteds}
                        closeAccordions={closeAccordions}
                        disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                        handleOpenAccordion={handleOpenAccordion}
                        isOyM={isOyM}
                        key={positionLine.id}
                        month={month.split(' ')[0]}
                        notificaPP={notificaPP}
                        refreshFetch={refreshFetch}
                        setAccordionsSelecteds={changeSetAccordionsSelecteds}
                        setRefreshFetch={setRefreshFetch}
                        setShowAddUbicationsToPLModal={setShowAddUbicationsToPLModal}
                        workPartPermissions={workPartPermissions}
                        year={month.split(' ')[1]}
                      />
                    ))}
                {showAddPLToUbicationModal && (
                  <AddPLToUbicationModal
                    contractNumber={contractNumber}
                    month={month.split(' ')[0]}
                    onSubmit={() => handleNewPositionLineAdded()}
                    setShowAddPLToUbicationModal={changeAddPLToUbicationState}
                    showAddPLToUbicationModal={showAddPLToUbicationModal}
                    ubicationsSelecteds={data.solicitudServicioMensualizadaUbicaciones?.filter(
                      (ubication) => accordionsSelecteds?.includes(ubication.id)
                    )}
                    withlocation
                    year={month.split(' ')[1]}
                  />
                )}
                {setShowAddUbicationsToPLModal && (
                  <AddUbicationsToPL
                    activeTemplateWorkReportModal={activeTemplateWorkReportModal}
                    contractNumber={contractNumber}
                    idServisRequestMonthly={id}
                    initialUbicationsSelecteds={data.solicitudServicioMensualizadaUbicaciones?.filter(
                      (ubication) => accordionsSelecteds?.includes(ubication.id)
                    )}
                    month={month.split(' ')[0]}
                    onSubmit={() => {
                      handleNewPositionLineAdded();
                    }}
                    positionsLinesSelecteds={data.parteTrabajoLineaMensualizadas?.filter(
                      (positionLine) => accordionsSelecteds?.includes(positionLine.id)
                    )}
                    setShowAddUbicationsToPLModal={setShowAddUbicationsToPLModal}
                    showAddUbicationsToPLModal={showAddUbicationsToPLModal}
                    year={month.split(' ')[1]}
                  />
                )}
              </>
            )}
          </>
        ) : (
          <NoUbications />
        )}
      </div>
      {/* IO detail modal from location list */}
      {modalImputationObject?.show && (
        <ModalMonthlyImputationObject
          canAddWellToImputationObject={
            workPartPermissions.addWellToObjectImputation && !disabledEditStateCancelOrFinish
          }
          canEditImputationObject={
            workPartPermissions.editObjectImputation && !disabledEditStateCancelOrFinish
          }
          data={modalImputationObject.data}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          idSolicitud={Number(requestData.nroSolicitud)}
          isOyM={isOyM}
          onClose={handleCloseModalImputationObject}
          show={modalImputationObject.show}
        />
      )}

      {/* Add location modal */}
      {modalAddLocation?.show && (
        <ModalAddLocation
          canAddWellToImputationObject={workPartPermissions.addWellToObjectImputation}
          canEditImputationObject={workPartPermissions.editObjectImputation}
          eventos={eventos}
          handleSubmit={submitAddLocationsMSDS}
          isTemplate={false}
          notFilterTypeOptions={false}
          onClose={handleCloseModalAddLocation}
          params={paramsLocation}
          setRefreshFetch={setRefreshFetch}
          show={modalAddLocation.show}
        />
      )}
      {showDeleteModal && (
        <DeleteUbicationModal
          handleDeleteUbication={deleteUbicationSelected}
          setShowDeleteModal={setShowDeleteModal}
          showDeleteModal={showDeleteModal}
          ubicationId={deleteUbicationInfo.id}
          ubicationName={deleteUbicationInfo.nombre}
        />
      )}
      {showFinishedServiceModal && (
        <FinishedServiceModal
          handleEndService={handleSetFinishedService}
          setShowFinishedServiceModal={handleShowModalFinishedService}
          showFinishedServiceModal={showFinishedServiceModal}
          ubicationData={finishedServiceInfo}
        />
      )}
    </>
  );
};

export default LocationWorkReports;

LocationWorkReports.propTypes = {
  asignationType: PropTypes.number.isRequired,
  contractNumber: PropTypes.string.isRequired,
  hasLocations: PropTypes.bool,
  month: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  workPartPermissions: WorkPartPermissions.isRequired,
  IOPermissions: TypeAndObjectImputationPermissions.isRequired,
  isOyM: PropTypes.bool.isRequired,
  idStatus: PropTypes.number.isRequired,
  filesPermissions: AttachedFilesPermissions,
  requestData: PropTypes.shape({
    nroSolicitud: PropTypes.string
  }).isRequired,
  getDetailsMonthlyHeader: PropTypes.func.isRequired,
  notificaPP: PropTypes.bool.isRequired,
  eventos: PropTypes.arrayOf(PropTypes.shape({}))
};

LocationWorkReports.defaultProps = {
  hasLocations: false,
  filesPermissions: {
    visualize: false,
    write: false
  },
  eventos: []
};
